<template>



    <v-container class="align-self-start">
      <v-row>

        <!-- Results -->
        <v-col cols="12" class="mx-auto" style="max-width:1000px;">


          <AvailabilityForm/>

          <!-- No Data -->
          <v-row v-if="!error && availCars && availCars.length === 0" class="text-center pa-3">
            <v-col cols="12">
              <v-alert type="warning">
                {{$t('booking.available_cars.no_cars_available')}}
              </v-alert>
            </v-col>
          </v-row>


          <AppAlert   :alert="error"/>


          <!-- Result page -->
          <v-row v-if="!error && availCars && availCars.length > 0" class="mt-3">
            <v-col v-for="availCar in availCars" :key="availCar.id" cols="12" lg="12">
              <AvailabilityCarCard class="mb-4" :availCar="availCar"/>
            </v-col>
          </v-row>

        </v-col>

      </v-row>
    </v-container>


</template>

<script>
  import { Header, Footer } from '@/modules/main';
  import { LocationsApi } from '@/shared/services';
  import { Availability } from '@/shared/models';
  import { AvailabilityCarCard } from '../components';
  import { Alert } from '../../../shared/models'

  export default {
    name: 'AvailableCars',
    data () {
      return {
        avail: null,
        availCars: null,
        isLoading: false,
        error: null
      };
    },
    methods: {
      findAvailCars () {
        this.avail = JSON.parse(decodeURIComponent(this.$route.query.data));
        console.log('Find', this.avail);
        this.error = null;
        this.isLoading = true;
        LocationsApi
          .findAvailCars(new Availability(this.avail))
          .then(availCars => {
            this.availCars = availCars;
          })
          .catch(error => {

            if (error.errorObj.status == 410) {
              this.error = new Alert({
                message: this.$i18n.t('main.availability_form.no_agency')
              });
            } else {
              this.error = error;
            }
          })
          .finally(() => this.isLoading = false);
      },

    },
    computed: {},
    mounted () {
      console.log("Availcars mounted ", this.avail)
      this.findAvailCars();
    },
    watch: {
      '$route.query.data': function () {
        this.findAvailCars();
      }
    },
    components: { AvailabilityCarCard }
  };
</script>

<style scoped>
</style>
